export default {
  Amount: 'GivingPageDonation.Amount',
  IsAmountCustom: 'GivingPageDonation.IsAmountCustom',
  RecaptchaResponse: 'RecaptchaResponse',
};



// WEBPACK FOOTER //
// ./src/onePageGiving/OnePageGivingFormFields.js